// extracted by mini-css-extract-plugin
module.exports = {"md":"ay"};